<!--
  대시보드 - ADS 트래픽 IP TOP 10

  @since 2023-11-28
  @author hoejun7.kim
-->
<template>
  <div
    ref="chartWrapper"
    class="widget-wrapper"
  >
    <div class="widget-contents">
      <div class="widget-contents-wrapper">
        <non-trend-chart
          ref="chartInstance"
          class="widget-contents-chart"
          :type="opts.chartType"
          :x-axis="xAxis"
          :y-axis="yAxis"
          :tooltip="toolTip"
          :data="widgetData"
          :series-options="seriesOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'

  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'

  // 스토어 헬퍼 객체
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetTrfTrafficMachIdTopn',
    mixins: [widgetMixin],
    data () {
      return {
        w: 1,
        opts: {
          chartType: 'bar'
        },
        title: 'widgetTrfTrafficMachIdTopn',
        isLock: false,
        isMove: true,
        isResize: true,
        eventBus: true,
        deviceType: [23],
        restData: {
          result: [],
          unit_time: ''
        },
        seriesOptions: {
          barWidth: '40%'
        },
        widgetData: []
      }
    },
    computed: {
      xAxis () {
        const xAxisOptions = {}

        if (this.opts.chartType === 'bar') {
          xAxisOptions.axisLabel = {
            formatter: (value) => {
              return `${this.byteConverter(value)}`
            }
          }
        }

        return xAxisOptions
      },
      yAxis () {
        const yAxisOptions = {}

        if (this.opts.chartType === 'column') {
          yAxisOptions.axisLabel = {
            formatter: (value) => {
              return `${this.byteConverter(value)}`
            }
          }
        }

        return yAxisOptions
      },
      toolTip () {
        return {
          formatter: (params) => {
            const {name, value, marker} = _.isArray(params) ? params[0] : params
            return `${marker} ${name} : <b>${this.byteConverter(value)}${this.restData.unit_time}</b>`
          }
        }
      },
      widgetChartMenu () {
        return [
          {
            icon: 'icon-chart-pie',
            label: 'Pie Chart',
            value: 'pie'
          },
          {
            icon: 'icon-chart-bar',
            label: 'Bar Chart',
            value: 'bar'
          },
          {
            icon: 'icon-chart-column',
            label: 'Column Chart',
            value: 'column'
          },
          {
            icon: 'icon-chart-tree-map',
            label: 'Tree Map',
            value: 'treemap'
          }
        ]
      }
    },
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        let contentsOptions = {
          widgetType: 'mach_id_traffic_session_top'
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams) {
          if (extraParams.machId) {
            contentsOptions.machId = extraParams.machId
          }
        }

        // Progress 출력 여부
        this.showProgress(true)

        // init Flag가 True라면 기존 데이터 초기화
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        // API 호출
        const {code, result} = await this.getWidgetData(contentsOptions)

        // Series 데이터 구성
        if (code === 'ok') {
          // Rest data 입력
          this.restData = result

          const machIdTrafficTop = []

          // this.restData.result.forEach(row => {
          _.forEach(this.restData.result, row => {
            machIdTrafficTop.push({
              name: _.escape(String(row.name)), // TAMS
              value: row.value
            })
          })

          this.widgetData = machIdTrafficTop
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    }
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .widget-contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-wrapper {
    flex-grow: 1;
    display: flex;
  }

  .widget-contents-chart {
    flex-grow: 1;
  }
</style>
